import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import PageIntroBanner from '../../components/PageIntroBanner';
import { colors } from '../../styles';

const styles = css`
.PageIntroBanner_body {
  ul {
    font-weight: 300;
    font-size: 19px;
    color: #3B3B3B;
    line-height: 35px;
  }
}
.alternatingSection {
  padding: 0 0 90px 0;
  .alternatingSection_media {
    background-position: center center;
    background-size: cover;
    img {
      width:100%;
      height:auto;
    }
  }
  .alternatingSection_content {
    margin-left: auto;
    flex-direction: column;
    justify-content: center;
    display: flex;
    .alternatingSection_title {
      font-weight: 200;
      font-size: 32px;
      color: ${colors.color1};
      letter-spacing: 0;
      line-height: 60px;
      margin: 0 0 30px 0;
      position: relative;
      @media (min-width: 768px) {
        font-size: 50px;
        margin: 0 0 60px 0;
      }
      &:after {
        content: '';
        display: block;
        background: ${colors.color2};
        width: 125px;
        height: 3px;
        position: absolute;
        left: 0;
        bottom: 0;
        @media (min-width: 768px) {
          bottom: -30px;
        }
      }
    }
    .alternatingSection_body {
      font-weight: 300;
      font-size: 19px;
      color: #3B3B3B;
      line-height: 35px;
      ol {
         list-style: none;
         counter-reset: item;
         padding: 0;
         li {
           counter-increment: item;
           margin-bottom: 5px;
           font-weight: 600;
         }
         li:before {
           margin-right: 10px;
           content: counter(item);
           background: ${colors.color2};
           border-radius: 100%;
           color: #FFFFFF;
           width: 30px;
           height: 30px;
           line-height: 30px;
           border-radius: 50%;
           text-align: center;
           display: inline-block;
           font-weight: 800;
         }
       }
    }
  }
  &:nth-child(even) {
    flex-direction: row-reverse;
    .alternatingSection_content {
      margin-left: 0;
    }
    .alternatingSection_media {
      margin-left: auto;
    }
  }
}

  main {
    padding:20px;
    @media (min-width: 480px) {
      padding:40px 0;
    }
    @media (min-width: 768px) {
      padding:60px 0;
    }
  }
`;

function Energy({ page }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuAbout />
        <PageIntroBanner
          heading={get(page, 'page_intro_banner[0].heading')}
          body={get(page, 'page_intro_banner[0].text')}
          image={get(page, 'page_intro_banner[0].image.contentUrl')}
        />
        <main className="container">
          {
            page.page_section1.map(item => (
              <div key={item.headline} className="alternatingSection row">
                <div className="alternatingSection_media col-lg-6">
                  <Image
                    src={get(item, 'photo.contentUrl')}
                    alt={get(item, 'title')}
                  />
                </div>
                <div className="alternatingSection_content col-lg-5">
                  <h4 className="alternatingSection_title">{item.headline}</h4>
                  <div className="alternatingSection_body">
                    <div dangerouslySetInnerHTML={SanitizeHtml(item.text)} />
                  </div>
                </div>
              </div>
            ))
          }
        </main>
      </PageWrapper>
    </div>
  );
}

Energy.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'energy_efficiency',
})(Energy);



// WEBPACK FOOTER //
// ./src/pages/Energy/index.js